import React, { useEffect } from "react";

import { invitationApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";
import useFilter from "../../../hooks/useFilter";
import scrollToTop from "../../../libs/scrollToTop";
import { calculatePageSize } from "../../../libs/pagingDetail";

import LoadingComponent from "../../../components/public/loading";
import PaginationComponent from "../../../components/public/pagination";
import UserReferralDetailComponent from "../../../components/private/user/userReferral/userReferralDetailComponent";

export default function UserReferralDetailContainer() {
  useEffect(() => {
    document.title = "اطلاعات کد معرف ";
    scrollToTop();
  }, []);

  const { run, isLoading, data } = useAxios({
    url: invitationApi,
    params: { order_by: "-id" },
  });
  const { onChange, filterState } = useFilter();

  useEffect(() => {
    run().then();
  }, [filterState["page"]]);

  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <UserReferralDetailComponent referralDetail={data?.results} />
          <PaginationComponent
            pageNumber={calculatePageSize(data?.count, filterState["page_size"])}
            currentPage={filterState["page"] || 1}
            handleChangePage={(e, value) => {
              onChange("page", value);
            }}
            className="mt-5"
            defaulPage={1}
          />
        </>
      )}
    </>
  );
}
